export const SHARE_ACTION = "shareAction";
